"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _PanelItems = require("../PanelItems");

var _Message = require("../../../ui-components/Message");

var _AccordionPanel = _interopRequireDefault(require("../../../panel/AccordionPanel"));

var _IntegrationPanel = require("./IntegrationPanel");

var _constants = require("@insided/shared/constants");

var _axios = _interopRequireDefault(require("axios"));

var _theLoops = require("./theLoops.constants");

var _TheLoops = require("./TheLoops.utils");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var IntegrationTabComponent = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(IntegrationTabComponent, _Component);

  var _super = _createSuper(IntegrationTabComponent);

  function IntegrationTabComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, IntegrationTabComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resizeObserver", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "panelBodyContainer", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      widgets: [],
      selectedWidget: '',
      showAutopilotNavbar: false,
      activePanelIndex: undefined,
      isScriptLoaded: false,
      previewWidth: undefined,
      lastSavedSelectedWidget: '',
      lastSavedShowAutopilotNavbar: false,
      lastSavedIsEnabled: false,
      enabled: false,
      isLoadingWidgets: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setupResizeObserver", function () {
      var panelBodyContainer = document.querySelector('.panel-body-container');

      if (panelBodyContainer) {
        _this.panelBodyContainer = panelBodyContainer;

        _this.initializeResizeObserver(panelBodyContainer);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cleanupResizeObserver", function () {
      if (_this.resizeObserver) {
        _this.resizeObserver.disconnect();

        _this.resizeObserver = undefined;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadAutopilotScript", function (cdnPrefix) {
      var baseUrl = cdnPrefix ? "https://".concat(cdnPrefix) : 'https://ask.autopilot.insided.com';
      var scriptSrc = "".concat(baseUrl, "/ask-embed.js?host=").concat(baseUrl);

      if (document.querySelector("script[src=\"".concat(scriptSrc, "\"]"))) {
        return;
      }

      var script = document.createElement('script');
      script.src = scriptSrc;
      script.async = true;

      script.onload = function () {
        return _this.setState({
          isScriptLoaded: true
        });
      };

      script.onerror = function () {
        console.error('Failed to load Autopilot script:', scriptSrc);
      };

      document.head.appendChild(script);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchWidgets", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var response, widgets, validWidgets, mappedWidgets, selectedWidget;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                widgetsError: undefined,
                isLoadingWidgets: true
              });

              _context.prev = 1;
              _context.next = 4;
              return _axios.default.get(_theLoops.THELOOPS_API_ENDPOINTS.GET_WIDGETS);

            case 4:
              response = _context.sent;

              if (response.data.success) {
                widgets = response.data.data || [];
                validWidgets = widgets.filter(function (widget) {
                  return widget.widgetId && widget.name;
                });
                mappedWidgets = validWidgets.map(function (widget) {
                  return {
                    id: widget.widgetId,
                    name: widget.name,
                    type: widget.type,
                    cdnPrefix: widget.cdnPrefix
                  };
                });
                selectedWidget = _this.props.selectedWidget; // If the current selection is invalid, reset to empty (shows "Select a widget")

                if (selectedWidget && !mappedWidgets.some(function (w) {
                  return w.id === selectedWidget;
                })) {
                  selectedWidget = '';
                }

                _this.setState({
                  widgets: mappedWidgets,
                  selectedWidget: selectedWidget,
                  widgetsError: undefined,
                  isLoadingWidgets: false
                }, function () {
                  if (selectedWidget) {
                    var _mappedWidgets$find;

                    _this.loadAutopilotScript((_mappedWidgets$find = mappedWidgets.find(function (w) {
                      return w.id === selectedWidget;
                    })) === null || _mappedWidgets$find === void 0 ? void 0 : _mappedWidgets$find.cdnPrefix);
                  }
                });
              } else {
                _this.setState({
                  widgetsError: 'Failed to load widgets.',
                  isLoadingWidgets: false
                });
              }

              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              console.error('Failed to fetch widgets:', _context.t0);

              _this.setState({
                widgetsError: 'Failed to load widgets. Please try again later.',
                isLoadingWidgets: false
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onAutopilotNavbarChange", function (event) {
      var target = event.target;

      _this.setState({
        showAutopilotNavbar: target.checked
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClickPanel", function (selectedPanel) {
      _this.setState({
        activePanelIndex: selectedPanel
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closePanel", function () {
      _this.setState({
        activePanelIndex: undefined
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCancel", function () {
      _this.setState(function (state) {
        return {
          selectedWidget: state.lastSavedSelectedWidget,
          showAutopilotNavbar: state.lastSavedShowAutopilotNavbar,
          enabled: state.lastSavedIsEnabled
        };
      });
    });
    return _this;
  }

  (0, _createClass2.default)(IntegrationTabComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isInstalled && this.props.isEnabled) {
        this.fetchWidgets();
      } // Initialize state from props safely


      this.setState({
        selectedWidget: this.props.selectedWidget,
        showAutopilotNavbar: this.props.autopilotNavbar,
        enabled: this.props.isEnabled,
        lastSavedSelectedWidget: this.props.selectedWidget,
        lastSavedShowAutopilotNavbar: this.props.autopilotNavbar,
        lastSavedIsEnabled: this.props.isEnabled
      }); // Setup ResizeObserver for preview width

      this.setupResizeObserver();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cleanupResizeObserver();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      // Fetch widgets when integration becomes installed and enabled
      if (this.props.isInstalled && this.props.isEnabled && (!prevProps.isInstalled || !prevProps.isEnabled)) {
        this.fetchWidgets();
      } // Sync prop changes into state


      if (this.props.selectedWidget !== prevProps.selectedWidget) {
        this.setState({
          selectedWidget: this.props.selectedWidget
        });
      }

      if (this.props.autopilotNavbar !== prevProps.autopilotNavbar) {
        this.setState({
          showAutopilotNavbar: this.props.autopilotNavbar
        });
      }

      if (this.props.isEnabled !== prevProps.isEnabled) {
        this.setState({
          enabled: this.props.isEnabled
        });
      } // Reload script when selected widget changes


      if (this.state.selectedWidget && prevState.selectedWidget !== this.state.selectedWidget) {
        var selectedWidget = this.state.widgets.find(function (w) {
          return w.id === _this2.state.selectedWidget;
        });

        if (selectedWidget !== null && selectedWidget !== void 0 && selectedWidget.cdnPrefix) {
          this.loadAutopilotScript(selectedWidget.cdnPrefix);
        }
      }
    }
  }, {
    key: "initializeResizeObserver",
    value: function initializeResizeObserver(container) {
      var _this3 = this;

      this.resizeObserver = new ResizeObserver(function (entries) {
        var _iterator = _createForOfIteratorHelper(entries),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var entry = _step.value;
            var _width = entry.contentRect.width;

            _this3.setState({
              previewWidth: _width
            });
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
      this.resizeObserver.observe(container);
      var width = container.getBoundingClientRect().width;
      this.setState({
        previewWidth: width
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          showUnsavedChangesModal = _this$props.showUnsavedChangesModal,
          closeModal = _this$props.closeModal,
          resetChanges = _this$props.resetChanges,
          isInstalled = _this$props.isInstalled,
          onToggleIntegration = _this$props.onToggleIntegration,
          onCompleteInstallation = _this$props.onCompleteInstallation,
          onSaveIntegrationSettings = _this$props.onSaveIntegrationSettings;
      var _this$state = this.state,
          widgets = _this$state.widgets,
          selectedWidget = _this$state.selectedWidget,
          showAutopilotNavbar = _this$state.showAutopilotNavbar,
          activePanelIndex = _this$state.activePanelIndex,
          isScriptLoaded = _this$state.isScriptLoaded,
          previewWidth = _this$state.previewWidth,
          enabled = _this$state.enabled,
          lastSavedSelectedWidget = _this$state.lastSavedSelectedWidget,
          lastSavedShowAutopilotNavbar = _this$state.lastSavedShowAutopilotNavbar,
          lastSavedIsEnabled = _this$state.lastSavedIsEnabled;
      var widgetSelectionError = this.state.widgetsError;

      if (!widgetSelectionError && widgets.length > 0 && !selectedWidget) {
        widgetSelectionError = 'Please select the widget';
      }

      var additionalInputFields = isInstalled && enabled ? (0, _preact.h)("div", {
        className: "integration-setup-fields"
      }, (0, _preact.h)(_TheLoops.WidgetSelection, {
        widgets: widgets,
        selectedWidget: selectedWidget,
        onWidgetChange: function onWidgetChange(widgetId) {
          return _this4.setState({
            selectedWidget: widgetId
          });
        },
        widgetsError: widgetSelectionError,
        isLoadingWidgets: this.state.isLoadingWidgets
      }), isScriptLoaded && selectedWidget && (0, _preact.h)(_TheLoops.WidgetPreview, {
        key: "widget-preview-".concat(selectedWidget),
        previewWidth: previewWidth,
        widgetDetails: widgets.find(function (widget) {
          return widget.id === selectedWidget;
        }),
        loopsTenantId: this.props.loopsTenantId
      }), (0, _preact.h)(_TheLoops.AdditionalConfigurations, {
        showAutopilotNavbar: showAutopilotNavbar,
        onAutopilotNavbarChange: this.onAutopilotNavbarChange
      })) : null;
      var hasUnsavedChanges = (0, _TheLoops.canSaveIntegrationSettings)(selectedWidget, showAutopilotNavbar, enabled, lastSavedSelectedWidget, lastSavedShowAutopilotNavbar, lastSavedIsEnabled);
      var IntegrationPanel = (0, _IntegrationPanel.getIntegrationPanel)({
        title: 'AI Answer Agent',
        isInstalled: isInstalled,
        imageToName: _constants.PLATFORM_INTEGRATION_LOGO_S_FILENAME,
        imageFromName: 'theloops-l',
        isSettingEnabled: enabled,
        onSettingChanged: function onSettingChanged() {
          _this4.setState(function (state) {
            return {
              enabled: !state.enabled,
              showAutopilotNavbar: !state.enabled
            };
          });

          onToggleIntegration();
        },
        onSave: function onSave() {
          var _this4$state = _this4.state,
              selectedWidget = _this4$state.selectedWidget,
              showAutopilotNavbar = _this4$state.showAutopilotNavbar,
              enabled = _this4$state.enabled;
          onSaveIntegrationSettings(showAutopilotNavbar, selectedWidget).then(function () {
            _this4.setState({
              lastSavedSelectedWidget: selectedWidget,
              lastSavedShowAutopilotNavbar: showAutopilotNavbar,
              lastSavedIsEnabled: enabled
            });

            _this4.closePanel();
          });
        },
        onCancel: this.handleCancel,
        showActionButtons: isInstalled,
        toggleLabel: 'Enable Integration',
        communityArticleLink: 'https://help.insided.com/theloops-integration-guide',
        description: (0, _preact.h)(_TheLoops.IntegrationDescription, {
          isInstalled: isInstalled,
          onCompleteInstallation: onCompleteInstallation
        }),
        additionalInputFields: additionalInputFields,
        additionalHelpText: null,
        storedIsSettingEnabled: enabled,
        hasUnsavedChanges: hasUnsavedChanges,
        customClass: 'qa-ai-answer-agent panel-body--expand--for-loop',
        onClickPanel: this.onClickPanel
      });
      return (0, _preact.h)("div", {
        className: "integration__tab"
      }, !isInstalled && (0, _preact.h)(_Message.Message, {
        text: "Please install the app first to configure the integrations.",
        fullWidth: true
      }), (0, _preact.h)(_AccordionPanel.default, {
        defaultActivePanelIndex: activePanelIndex,
        panels: [IntegrationPanel]
      }), (0, _preact.h)(_PanelItems.UnsavedChangesModal, {
        showUnsavedChangesModal: showUnsavedChangesModal,
        closeModal: closeModal,
        resetChanges: resetChanges
      }));
    }
  }]);
  return IntegrationTabComponent;
}(_preact.Component);

var IntegrationTab = function IntegrationTab(props) {
  return (0, _preact.h)(IntegrationTabComponent, props);
};

var _default = IntegrationTab;
exports.default = _default;